import PumpPlc from "../PumpPlc/PumpPlc";
import { getOllPchError } from '../../../Utils/ErrorPch'; //функция с ошибками частотников 
import { checkBit, checkExistNA, parseBits, stateNA, formatParametr } from '../../../Utils/Functions';

export default function PrepDataPlc({pumpsData}) {

// Функция для определения состояния аварийных индикаторов на основе значения bits4to7
    const getAlarmStates = (bits4to7) => {
        if (bits4to7 === undefined || bits4to7 === null || bits4to7 === 0) {
            return {
                commError: false,
                pressureAlarm: false,
                dryRun: false,
                flowError: false,
                driveFault: false
            };
        }

    // Определяем состояния индикаторов на основе числового значения
        return {
            commError: bits4to7 === 1,     // Отсутствие связи с ПЧ
            driveFault: bits4to7 === 2,    // Авария ПЧ
            dryRun: bits4to7 === 3,        // Сухой ход
            flowError: bits4to7 === 4,     // Отсутствие потока
            pressureAlarm: bits4to7 === 5  // Аварийное давление
        };
    };

  // Функция для подготовки данных насоса
    const preparePumpData = (pumpIndex) => {
        let pumpData = {};
        
        switch(pumpIndex) {
            case 1:
                if (!checkExistNA(pumpsData?.param5)) return null;
                pumpData.pumpNumber = pumpIndex;
                pumpData.mode = checkBit(pumpsData?.param4, 0) ? 'Автоматический' : 'Ручной';
                const result1 = parseBits(pumpsData?.param5);
                pumpData.status = stateNA(result1.bits0to3);
                pumpData.speed = formatParametr(pumpsData?.param7, 1, 'Гц');
                pumpData.current = formatParametr(pumpsData?.param6, 1, 'А');
                
                // Получаем состояния аварийных индикаторов на основе числового значения bits4to7
                const alarms1 = getAlarmStates(result1.bits4to7);
                Object.assign(pumpData, alarms1);
                
                // Определяем аварию ПЧ и получаем детали
                pumpData.driveFault = pumpData.driveFault || result1.bits8to15 !== 0;
                pumpData.faultDetails = getOllPchError(result1.bits8to15);
                break;
                
            case 2:
                if (!checkExistNA(pumpsData?.param8)) return null;
                pumpData.pumpNumber = pumpIndex;
                pumpData.mode = checkBit(pumpsData?.param4, 1) ? 'Автоматический' : 'Ручной';
                const result2 = parseBits(pumpsData?.param8);
                pumpData.status = stateNA(result2.bits0to3);
                pumpData.speed = formatParametr(pumpsData?.param10, 1, 'Гц');
                pumpData.current = formatParametr(pumpsData?.param9, 1, 'А');
                
                const alarms2 = getAlarmStates(result2.bits4to7);
                Object.assign(pumpData, alarms2);
                
                pumpData.driveFault = pumpData.driveFault || result2.bits8to15 !== 0;
                pumpData.faultDetails = getOllPchError(result2.bits8to15);
                break;
                
            case 3:
                if (!checkExistNA(pumpsData?.param11)) return null;
                pumpData.pumpNumber = pumpIndex;
                pumpData.mode = checkBit(pumpsData?.param4, 2) ? 'Автоматический' : 'Ручной';
                const result3 = parseBits(pumpsData?.param11);
                pumpData.status = stateNA(result3.bits0to3);
                pumpData.speed = formatParametr(pumpsData?.param13, 1, 'Гц');
                pumpData.current = formatParametr(pumpsData?.param12, 1, 'А');
                
                const alarms3 = getAlarmStates(result3.bits4to7);
                Object.assign(pumpData, alarms3);
                
                pumpData.driveFault = pumpData.driveFault || result3.bits8to15 !== 0;
                pumpData.faultDetails = getOllPchError(result3.bits8to15);
                break;
                
            case 4:
                if (!checkExistNA(pumpsData?.param14)) return null;
                pumpData.pumpNumber = pumpIndex;
                pumpData.mode = checkBit(pumpsData?.param4, 3) ? 'Автоматический' : 'Ручной';
                const result4 = parseBits(pumpsData?.param14);
                pumpData.status = stateNA(result4.bits0to3);
                pumpData.speed = formatParametr(pumpsData?.param16, 1, 'Гц');
                pumpData.current = formatParametr(pumpsData?.param15, 1, 'А');
                
                const alarms4 = getAlarmStates(result4.bits4to7);
                Object.assign(pumpData, alarms4);
                
                pumpData.driveFault = pumpData.driveFault || result4.bits8to15 !== 0;
                pumpData.faultDetails = getOllPchError(result4.bits8to15);
                break;
                
            default:
                return null;
        }
        
        return pumpData;
    };

    // Подготавливаем данные для всех насосов
    const pump1Data = preparePumpData(1);
    const pump2Data = preparePumpData(2);
    const pump3Data = preparePumpData(3);
    const pump4Data = preparePumpData(4);

    return (
        <> 
            {pump1Data && <PumpPlc 
                pumpNumber={pump1Data.pumpNumber}
                mode={pump1Data.mode}
                status={pump1Data.status}
                speed={pump1Data.speed}
                current={pump1Data.current}
                commError={pump1Data.commError}
                pressureAlarm={pump1Data.pressureAlarm}
                dryRun={pump1Data.dryRun}
                flowError={pump1Data.flowError}
                driveFault={pump1Data.driveFault}
                faultDetails={pump1Data.faultDetails}
            />}
            
            {pump2Data && <PumpPlc 
                pumpNumber={pump2Data.pumpNumber}
                mode={pump2Data.mode}
                status={pump2Data.status}
                speed={pump2Data.speed}
                current={pump2Data.current}
                commError={pump2Data.commError}
                pressureAlarm={pump2Data.pressureAlarm}
                dryRun={pump2Data.dryRun}
                flowError={pump2Data.flowError}
                driveFault={pump2Data.driveFault}
                faultDetails={pump2Data.faultDetails}
            />}
            
            {pump3Data && <PumpPlc 
                pumpNumber={pump3Data.pumpNumber}
                mode={pump3Data.mode}
                status={pump3Data.status}
                speed={pump3Data.speed}
                current={pump3Data.current}
                commError={pump3Data.commError}
                pressureAlarm={pump3Data.pressureAlarm}
                dryRun={pump3Data.dryRun}
                flowError={pump3Data.flowError}
                driveFault={pump3Data.driveFault}
                faultDetails={pump3Data.faultDetails}
            />}
            
            {pump4Data && <PumpPlc
                pumpNumber={pump4Data.pumpNumber} 
                mode={pump4Data.mode}
                status={pump4Data.status}
                speed={pump4Data.speed}
                current={pump4Data.current}
                commError={pump4Data.commError}
                pressureAlarm={pump4Data.pressureAlarm}
                dryRun={pump4Data.dryRun}
                flowError={pump4Data.flowError}
                driveFault={pump4Data.driveFault}
                faultDetails={pump4Data.faultDetails}
            />}
        </>
    )
}